import { useEffect, useState } from "react";
import { BrandMark } from "@/components/BrandLogo";

const KEY = "nbm_intro_seen";

// ~1.2s gold-and-purple logo reveal, once per browser session; click to skip; off for reduced motion.
export const LogoIntro = () => {
  const [on, setOn] = useState(() => {
    try { return !sessionStorage.getItem(KEY) && !window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch { return false; }
  });
  useEffect(() => {
    if (!on) return undefined;
    try { sessionStorage.setItem(KEY, "1"); } catch { /* private mode */ }
    const t = setTimeout(() => setOn(false), 1700);
    return () => clearTimeout(t);
  }, [on]);
  if (!on) return null;
  return (
    <div onClick={() => setOn(false)} className="nbm-intro fixed inset-0 z-[100] flex items-center justify-center bg-[#09090B]" data-testid="logo-intro" aria-hidden="true">
      <span className="nbm-burst pointer-events-none absolute h-[520px] w-[520px] rounded-full" />
      <div className="relative flex items-center gap-3 px-4 sm:gap-4">
        <span className="nbm-mark"><BrandMark className="h-14 w-14 sm:h-20 sm:w-20" /></span>
        <span className="flex flex-col leading-none">
          <span className="nbm-word whitespace-nowrap font-display text-[26px] font-bold tracking-[-0.02em] sm:text-5xl">
            <span className="text-white">MyNext</span><span className="nbm-gold">BigMove</span><span className="text-[#B57BFF] [text-shadow:0_0_18px_rgba(130,36,227,0.9)]">.com</span>
          </span>
          <span className="nbm-tag mt-2 font-mono text-[9px] font-semibold uppercase tracking-[0.32em] text-zinc-500 sm:text-[11px]">powered by <span className="text-[#D4AF37]">RPOPRO.co</span></span>
        </span>
      </div>
    </div>
  );
};
